import { linkedPackage } from 'lincd/utils/Package';
export const { linkedComponent, linkedShape, linkedUtil, linkedOntology, registerPackageExport, packageExports, packageName, } = linkedPackage('lincd-form');
//# sourceMappingURL=package.js.map